export const REQUEST_API = "Table/REQUEST_API";
export const GET_RESPONSE_API = "Table/GET_RESPONSE_API";
export const GET_ERROR_API = "Table/GET_ERROR_API";
